import styled, { css, keyframes } from "styled-components";
import { Link as ReactRouterLink } from "react-router-dom";
import TypographyUi from "../Typography";

export const Typography = styled(TypographyUi)<{ width; height }>`
  background: #f1f4f9;
  border-radius: 3px;
  width: ${({ width }) => width}px;
  height: ${({ height }) => height}px;
  margin-top: 0px;
  margin-bottom: 0px;
`;

export const Card = styled("div")`
  background-color: white;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  padding: 10px;
  position: relative;
  overflow: hidden;
`;

export const Thumbnail = styled("div")<{ background }>`
  width: 90px;
  height: 90px;
  background-image: url(${({ background }) => background});
  background-position: center;
  background-size: cover;
  border-radius: 5px;
  flex-shrink: 0;
  background-color: #f1f4f9;
`;

export const Title = styled("h3")`
  width: 100%;
  margin: 0px;
  font-size: 14px;
  font-weight: 500;
`;

export const Progress = styled("div")``;
export const Link = styled(ReactRouterLink)``;

const slideAnimation = keyframes`
  from {
    transform:translateX(-25%);
  }
  to {
    transform:translateX(25%);
  }
`;

const bgstyles = css`
  animation: ${slideAnimation} 3s ease-in-out infinite alternate;
  background-image: linear-gradient(
    -60deg,
    rgb(202, 202, 202) 50%,
    rgb(174, 174, 174) 50%
  );
  bottom: 0;
  left: -50%;
  opacity: 0.5;
  position: absolute;
  right: -50%;
  top: 0;
  z-index: 1;
`;

export const Bg = styled("div")`
  ${bgstyles}
`;

export const Bg2 = styled("div")`
  ${bgstyles}
  animation-direction:alternate-reverse;
  animation-duration: 4s;
`;

export const Bg3 = styled("div")`
  ${bgstyles}
  animation-duration:5s;
`;
